import { createApiClient, responseData } from '#lib/api/client.js';

export const getNewsSearch = async (
	fetchFn: typeof globalThis.fetch,
	query: { searchPhrase: string; limit: number }
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/news-search', {
			params: { query },
		})
	);
